export default "__VITE_ASSET__BB2zEss3__"